import api from '@/utils/api';
import {
    FETCH_LABOS,
    FETCH_LABO_DETAIL,
    CREATE_LABO,
    UPDATE_LABO,
    DELETE_LABOS,
    FETCH_ACTIVE_LABOS
} from './types';
import { NotificationManager } from 'react-notifications';

/**
 * Lấy danh sách bản ghi với điều kiện lọc và phân trang.
 * @param {Object} filters Các bộ lọc: { keyword, status, page, per_page }
 */
export const fetchLaboList = (filters) => dispatch => {
    return api.get('/labos', { params: filters }).then(res => {
        dispatch({ type: FETCH_LABOS, payload: res.data.data });
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể tải danh sách');
        throw err;
    });
};

/**
 * Lấy danh sách bản ghi đang hoạt động (active).
 * @param {Object} filters Các bộ lọc: { keyword, status, page, per_page }
 */
export const fetchActiveLabos = (filters = {}) => dispatch => {
    return api.get('/labos/active', { params: filters }).then(res => {
        dispatch({ type: FETCH_ACTIVE_LABOS, payload: res.data.data });
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể tải danh sách active');
        throw err;
    });
};


/**
 * Lấy chi tiết một bản ghi theo ID.
 * @param {number} id
 */
export const fetchLaboDetail = (id) => dispatch => {
    return api.get(`/labos/${id}`).then(res => {
        dispatch({ type: FETCH_LABO_DETAIL, payload: res.data.data });
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể lấy chi tiết');
        throw err;
    });
};

/**
 * Tạo mới một bản ghi.
 * @param {Object} data Dữ liệu cần gửi lên server
 */
export const createLabo = (data) => dispatch => {
    return api.post('/labos', data).then(res => {
        dispatch({ type: CREATE_LABO, payload: res.data.data });
        NotificationManager.success(res.data.msg || 'Tạo thành công');
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Tạo thất bại');
        throw err;
    });
};

/**
 * Cập nhật một bản ghi theo ID.
 * @param {number} id
 * @param {Object} data Dữ liệu cập nhật
 */
export const updateLabo = (id, data) => dispatch => {
    return api.put(`/labos/${id}`, data).then(res => {
        dispatch({ type: UPDATE_LABO, payload: res.data.data });
        NotificationManager.success(res.data.msg || 'Cập nhật thành công');
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Cập nhật thất bại');
        throw err;
    });
};

/**
 * Xoá nhiều bản ghi theo danh sách ID.
 * @param {number[]} ids
 */
export const deleteLabos = (ids) => dispatch => {
    return api.delete('/labos', { data: { ids } }).then(res => {
        dispatch({ type: DELETE_LABOS, payload: ids });
        NotificationManager.success(res.data.msg || 'Xoá thành công');
        return res.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Xoá thất bại');
        throw err;
    });
};